import { Dispatch } from "@reduxjs/toolkit";
import { logout } from "../store/slices/authSlice.ts";
import { resetAdminNotifications } from "../store/slices/adminNotificationsSlice.ts";

/**
 * Same logout process used by the navbar "Cerrar sesión" action:
 * clears persisted auth (token, user, partner) and in-memory notification state.
 * redux-persist whitelist is only `auth`, so resetting that slice clears localStorage.
 */
export function clearAuthSession(dispatch: Dispatch) {
  dispatch(resetAdminNotifications());
  dispatch(logout());
}
